<template>
  <div v-if="showModuloForm === false">
    <MarketingModules></MarketingModules>
  </div>
  <div class="page" v-else-if="showModuloForm === true">
    <Panel lineColor="var(--primary-color)">
      <template v-slot:options>
        <FormButton
          text="Ver Relatório"
          type="auxiliar"
          @click="goToReport"
          beforeIcon="fas fa-chart-bar"
          class="mb-3"
        />
      </template>
      <v-row>
        <v-col cols="12" class="pb-0">
          <div class="secao-titulo">Canal de envio</div>
          <div class="secao-subtitulo">
            Escolha para onde a notificação será enviada.
          </div>
        </v-col>
        <v-col cols="12">
          <v-row dense>
            <v-col
              v-for="opcao in opcoesCanal"
              :key="opcao.valor"
              cols="12"
              md="4"
            >
              <div
                class="canal-opcao"
                :class="{
                  'canal-opcao--ativa': canalEnvio === opcao.valor,
                  'canal-opcao--desabilitada': opcao.desabilitada
                }"
                @click="selecionarCanal(opcao)"
              >
                <v-icon
                  size="18"
                  :color="canalEnvio === opcao.valor ? 'primario' : 'grey'"
                >
                  {{
                    canalEnvio === opcao.valor
                      ? "fas fa-dot-circle"
                      : "far fa-circle"
                  }}
                </v-icon>
                <div class="canal-opcao__icones">
                  <span
                    v-for="(icone, i) in opcao.icones"
                    :key="icone"
                    class="canal-opcao__icone-wrapper"
                  >
                    <span v-if="i > 0" class="canal-opcao__mais">+</span>
                    <span class="canal-opcao__icone">
                      <v-icon size="18" color="primario">{{ icone }}</v-icon>
                    </span>
                  </span>
                </div>
                <div class="canal-opcao__texto">
                  <div class="canal-opcao__titulo">{{ opcao.titulo }}</div>
                  <div class="canal-opcao__descricao">
                    {{ opcao.descricao }}
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="pt-0">
          <div class="canal-aviso">
            <v-icon size="16" color="primario" class="mr-2">
              fas fa-info-circle
            </v-icon>
            <span v-if="canalWebDisponivel">
              Se ambos estiverem selecionados, a notificação será entregue no
              app e no navegador compatível.
            </span>
            <span v-else>
              Esta loja não possui o canal de web push configurado, então o
              envio será feito somente para o aplicativo.
            </span>
          </div>
        </v-col>
        <v-col cols="12" class="pb-0">
          <div class="secao-titulo">Quando enviar?</div>
          <div class="secao-subtitulo">
            Envie agora ou programe a notificação para uma data e horário
            futuros.
          </div>
        </v-col>
        <v-col cols="12">
          <v-row dense>
            <v-col
              v-for="opcao in opcoesQuando"
              :key="opcao.valor"
              cols="12"
              md="6"
            >
              <div
                class="canal-opcao"
                :class="{
                  'canal-opcao--ativa': quando === opcao.valor,
                  'canal-opcao--desabilitada': opcao.desabilitada
                }"
                @click="selecionarQuando(opcao)"
              >
                <v-icon
                  size="18"
                  :color="quando === opcao.valor ? 'primario' : 'grey'"
                >
                  {{
                    quando === opcao.valor
                      ? "fas fa-dot-circle"
                      : "far fa-circle"
                  }}
                </v-icon>
                <div class="canal-opcao__icones">
                  <span class="canal-opcao__icone">
                    <v-icon size="18" color="primario">{{ opcao.icone }}</v-icon>
                  </span>
                </div>
                <div class="canal-opcao__texto">
                  <div class="canal-opcao__titulo">{{ opcao.titulo }}</div>
                  <div class="canal-opcao__descricao">
                    {{ opcao.descricao }}
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="3" v-if="agendando" class="pb-0">
          <FormDatePicker
            v-model="agendamento.data"
            label="Data do envio"
            :min="hoje"
            :clearable="false"
            :validation="errosAgendamento.data ? { $dirty: true } : null"
            :error-message="{ custom: errosAgendamento.data }"
            @change="errosAgendamento = {}"
          />
        </v-col>
        <v-col cols="12" md="3" v-if="agendando" class="pb-0">
          <FormField
            v-model="agendamento.hora"
            type="mask"
            mask="##:##"
            label="Horário do envio"
            placeholder="HH:mm"
            hint="Horário de Brasília"
            persistenthint
            :validation="errosAgendamento.hora ? { $dirty: true } : null"
            :error-message="{ custom: errosAgendamento.hora }"
            @input="errosAgendamento = {}"
          />
        </v-col>
        <v-col cols="12" class="pt-0">
          <div class="canal-aviso">
            <v-icon size="16" color="primario" class="mr-2">
              fas fa-info-circle
            </v-icon>
            <span>
              Para consultar, editar ou cancelar notificações agendadas, acesse
              <a href="#" @click.prevent="goToReport('agendamentos')">
                Ver Relatório &gt; Agendamentos</a
              >.
            </span>
          </div>
        </v-col>
        <v-col cols="12" class="pb-0">
          <div class="secao-titulo">Segmentação de clientes</div>
          <div class="secao-subtitulo">
            Defina os filtros para selecionar o público que receberá a
            notificação.
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <v-row no-gutters>
            <v-col cols="12" class="text-start px-3">Data de cadastro</v-col>
            <v-col cols="6" class="px-1">
              <FormDatePicker
                v-model="filter.dataCadastroIni"
                label="Inicial"
              />
            </v-col>
            <v-col cols="6" class="px-1">
              <FormDatePicker
                v-model="filter.dataCadastroFim"
                :min="filter.dataCadastroIni"
                label="Final"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="3">
          <v-row no-gutters>
            <v-col cols="12" class="text-start px-3">
              Data da última compra
            </v-col>
            <v-col cols="6" class="px-1">
              <FormDatePicker
                v-model="filter.dataUltimaCompraIni"
                label="Inicial"
              />
            </v-col>
            <v-col cols="6" class="px-1">
              <FormDatePicker
                v-model="filter.dataUltimaCompraFim"
                :min="filter.dataUltimaCompraIni"
                label="Final"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="3">
          <v-row no-gutters>
            <v-col cols="12" class="text-start px-3">
              Data do último acesso
            </v-col>
            <v-col cols="6" class="px-1">
              <FormDatePicker
                v-model="filter.dataUltimoAcessoIni"
                label="Inicial"
              />
            </v-col>
            <v-col cols="6" class="px-1">
              <FormDatePicker
                v-model="filter.dataUltimoAcessoFim"
                :min="filter.dataUltimoAcessoIni"
                label="Final"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="3">
          <v-row no-gutters>
            <v-col cols="12" class="text-start px-3">
              Data de nascimento
            </v-col>
            <v-col cols="6" class="px-1">
              <FormDatePicker
                v-model="filter.dataNascimentoIni"
                label="Inicial"
              />
            </v-col>
            <v-col cols="6" class="px-1">
              <FormDatePicker
                v-model="filter.dataNascimentoFim"
                :min="filter.dataNascimentoIni"
                label="Final"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="4">
          <FormAutocomplete
            label="Atendente(s) padrão"
            placeholder="Pesquisa pelo nome do atendente"
            :options="optionsAtendente"
            @search="onSearchAtendente"
            v-model="filter.atendentesPadrao"
            useTemplate
            multiple
            chips
            clearable
          >
            <template v-slot:item="{ item }">
              <div class="atendente-123 d-flex flex-column align-start">
                <p style="margin-bottom:0!important">{{ item.text }}</p>
              </div>
            </template>
          </FormAutocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-row no-gutters>
            <FormSelect
              class="mb-n5"
              label="Segmentos"
              v-model="filter.segmentosSelecionados"
              multiple
              :options="segmentos"
            />
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" class="ml-3 mt-n2">
                  far fa-question-circle
                </v-icon>
              </template>
              Agrupamento de clientes por comportamento de compra.
            </v-tooltip>
          </v-row>
        </v-col>
        <v-col cols="12" md="4">
          <v-row no-gutters>
            <FormSelect
              class="mb-n5"
              label="Lojas em que fez pedido"
              v-model="filter.fornecedoresSelecionados"
              multiple
              :options="fornecedores"
            />
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" class="ml-3 mt-n2">
                  far fa-question-circle
                </v-icon>
              </template>
              Agrupamento de clientes por comportamento de compra.
            </v-tooltip>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-n3">
          <v-row no-gutters>
            <FormCheckbox
              v-model="filter.carrinhoAberto"
              label="Apenas carrinho em aberto"
              class="mx-5"
            />
            <FormCheckbox
              v-model="filter.cadastroaprovado"
              label="Apenas cadastro aprovado"
              class="mx-5"
            />
            <FormCheckbox
              v-model="filter.enviarParaTodos"
              label="Enviar para todos clientes"
              class="mx-5"
            />
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" class="mt-n2">
                  far fa-question-circle
                </v-icon>
              </template>
              Ao enviar para todos os clientes, será enviado a notificação para
              todos os clientes de acordo com o filtro informado acima.
            </v-tooltip>
          </v-row>
        </v-col>
        <v-col cols="12" class="text-end">
          <FormButton
            :disabled="filter.enviarParaTodos"
            type="primario"
            :loading="isLoading"
            @click="getClientes(true)"
          >
            Pesquisar
          </FormButton>
        </v-col>
      </v-row>
    </Panel>
    <Panel
      lineColor="var(--primary-color)"
      class="mt-5"
      v-if="clientes.length > 0 || filter.enviarParaTodos"
    >
      <v-row>
        <v-col cols="12" md="6" class="pr-md-6" v-if="!filter.enviarParaTodos">
          <v-row no-gutters>
            <v-col cols="6" class="text-start"><h4>Pesquisa</h4></v-col>
            <v-col cols="6" class="text-end">
              <small class="mr-5"
                >{{ clientes.length }} clientes encontrados</small
              >
              <FormButton
                @click="addAllCliente(clientes)"
                type="success"
                v-if="clientes.length > 0"
              >
                <v-icon class="mr-3">fa-plus</v-icon>
                Adicionar Todos
              </FormButton>
            </v-col>
            <v-col cols="12" class="text-start">
              <div class="scroll-container mt-10" @scroll="onScroll">
                <v-simple-table @scroll="onScroll" v-if="clientes.length > 0">
                  <tbody>
                    <tr v-for="(cliente, i) in clientes" :key="i">
                      <td>
                        {{ cliente.nome }}
                        <v-tooltip right v-if="cliente.carrinhoaberto">
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              class="ml-3"
                              color="green"
                              size="15"
                            >
                              fa-cart-plus
                            </v-icon>
                          </template>
                          Tem carrinho aberto!
                        </v-tooltip>
                      </td>
                      <td>
                        <v-row no-gutters>
                          <v-col cols="12" class="text-no-wrap">
                            Data de cadastro:
                            {{ formataData(cliente.datacadastro) }}
                          </v-col>
                          <v-col cols="12" class="text-no-wrap">
                            Data de nascimento:
                            {{ formataData(cliente.datanascimento) }}
                          </v-col>
                        </v-row>
                      </td>
                      <td>
                        <v-row no-gutters>
                          <v-col cols="12" class="text-no-wrap">
                            Último acesso:
                            {{ formataData(cliente.ultimoacesso) }}
                          </v-col>
                          <v-col cols="12" class="text-no-wrap">
                            Última compra:
                            {{ formataData(cliente.ultimacompra) }}
                          </v-col>
                        </v-row>
                      </td>
                      <td>
                        <FormButton
                          @click="addCliente(cliente)"
                          icon
                          type="success"
                          v-if="
                            !clientesSelecionados.includes(cliente.idcliente)
                          "
                        >
                          <v-icon>fa-plus</v-icon>
                        </FormButton>
                        <FormButton
                          @click="removeCliente(cliente)"
                          icon
                          type="error"
                          v-else
                        >
                          <v-icon>fa-trash</v-icon>
                        </FormButton>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          :md="filter.enviarParaTodos ? '12' : '6'"
          class="pl-md-6"
          :class="!filter.enviarParaTodos ? 'border-left' : ''"
        >
          <v-row no-gutters>
            <v-col cols="12" md="7">
              <h4 class="text-start mb-5">Composição</h4>
              <FormField
                label="Título"
                placeholder="Título da notificação"
                v-model="form.messageTitle"
              />
              <FormText
                label="Texto"
                placeholder="Mensagem da notificação"
                :rows="8"
                v-model="form.messageText"
              />
              <FormField
                label="Link (Opcional)"
                placeholder="Link externo"
                v-model="form.messageLink"
                @blur="verifyMessageLink"
              />
            </v-col>
            <v-col cols="12" md="5">
              <v-img
                src="@/assets/preview-smartphone.png"
                width="320px"
                class="mx-auto"
              >
                <div class="white text-start preview-smartphone pa-2">
                  <h4 class="font-weight-bold text-no-wrap text-truncate">
                    {{ form.messageTitle }}
                  </h4>
                  <span>{{ form.messageText }}</span>
                </div>
              </v-img>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </Panel>
    <Panel
      lineColor="var(--primary-color)"
      class="mt-5"
      v-if="clientes.length > 0 || filter.enviarParaTodos"
    >
      <v-row>
        <v-col cols="12" class="text-start" v-if="listaClientes.length > 0">
          <v-simple-table>
            <tbody>
              <tr v-for="(cliente, i) in listaClientes" :key="i">
                <td>
                  {{ cliente.nome }}
                </td>
                <td class="text-end">
                  <FormButton @click="removeCliente(cliente)" icon type="error">
                    <v-icon>fa-trash</v-icon>
                  </FormButton>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
        <v-col cols="12" class="text-end mt-5">
          <FormButton
            v-if="listaClientes.length > 0"
            type="error"
            class="mr-3"
            :loading="isLoading"
            @click="removeAllCliente()"
          >
            Remover todos os clientes
          </FormButton>
          <FormButton type="primario" :loading="isLoading" @click="onSubmit()">
            {{ textoBotaoEnvio }}
          </FormButton>
        </v-col>
      </v-row>
    </Panel>
    <Panel lineColor="var(--primary-color)" class="mt-5" v-else>
      <div class="pa-md-5">
        <v-icon
          size="64"
          color="primario"
          class="pa-5"
          style="border: 3px solid; border-radius: 50%;"
        >
          fa-users
        </v-icon>
        <p class="pt-3 primario--text font-weight-bold" style="font-size: 2em;">
          Pesquise os clientes...
        </p>
        <p class="primario--text font-weight-bold">
          Os resultados aparecerão aqui!
        </p>
      </div>
    </Panel>
  </div>
</template>

<script>
import Panel from "@/components/Panel";
import FormButton from "@/components/form/FormButton";
import FormSelect from "@/components/form/FormSelect";
import FormField from "@/components/form/FormField";
import FormText from "@/components/form/FormText";
import FormCheckbox from "@/components/form/FormCheckbox";
import FormDatePicker from "@/components/form/FormDatePicker";
import FormAutocomplete from "@/components/form/FormAutocomplete";
import { mapGetters } from "vuex";
import MarketingModules from "@/components/MarketingModules";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import { SEGMENTO_CLIENTE_LIST } from "@/store/actions/segmento";
import { FORNECEDOR_LOAD_ALL } from "@/store/actions/fornecedor";
import {
  NOTIFICACAO_PUSH_LOAD_CLIENTS,
  NOTIFICACAO_PUSH_SEND,
  NOTIFICACAO_PUSH_AGENDAR,
  NOTIFICACAO_PUSH_GET_AGENDAMENTO,
  NOTIFICACAO_PUSH_ATUALIZAR_AGENDAMENTO
} from "@/store/actions/notificacaoPush";
import {
  QUANDO_AGORA,
  QUANDO_AGENDAR,
  MENSAGEM_EM_PROCESSAMENTO,
  podeAlterarAgendamento,
  validarDataHoraAgendamento,
  separarDataHoraBrasilia,
  hojeBrasilia
} from "./agendamento-helpers";
import moment from "moment";
import ApiWeb from "../../../service/api-web";
import * as _ from "lodash";

export default {
  name: "NotificacaoPush",
  computed: {
    ...mapGetters(["getFornecedorId", "moduloFornecedorAtivo"]),
    showModuloForm() {
      return this.moduloFornecedorAtivo(this.modulosForm);
    },
    listaClientes() {
      const idSet = new Set();
      const clientes = [];
      for (const cliente of this.listaDestinatarios || []) {
        if (!idSet.has(cliente.idcliente)) {
          idSet.add(cliente.idcliente);
          clientes.push(cliente);
        }
      }
      return clientes || [];
    },
    optionsAtendente() {
      return (this.atendentesResult || []).map(item => ({
        text: this.formataNome(item),
        value: item.idusuario
      }));
    },
    opcoesCanal() {
      return [
        {
          valor: "ambos",
          titulo: "Aplicativo + Web Push",
          descricao: "Envia a notificação no aplicativo e no navegador.",
          icones: ["fas fa-mobile-alt", "fas fa-desktop"],
          desabilitada: !this.canalWebDisponivel
        },
        {
          valor: "app",
          titulo: "Aplicativo",
          descricao: "Envia a notificação apenas no aplicativo.",
          icones: ["fas fa-mobile-alt"],
          desabilitada: false
        },
        {
          valor: "web",
          titulo: "Web Push",
          descricao: "Envia a notificação apenas no navegador.",
          icones: ["fas fa-desktop"],
          desabilitada: !this.canalWebDisponivel
        }
      ];
    },
    editando() {
      return !!this.idAgendamentoEdicao;
    },
    agendando() {
      return this.quando === QUANDO_AGENDAR;
    },
    hoje() {
      return hojeBrasilia();
    },
    textoBotaoEnvio() {
      if (this.editando) return "Salvar alterações";
      return this.agendando ? "Agendar notificação" : "Enviar Mensagem";
    },
    opcoesQuando() {
      return [
        {
          valor: QUANDO_AGORA,
          titulo: "Enviar agora",
          descricao: "A notificação é enviada assim que você confirmar.",
          icone: "fas fa-paper-plane",
          desabilitada: this.editando
        },
        {
          valor: QUANDO_AGENDAR,
          titulo: "Agendar envio",
          descricao: "Defina uma data e horário futuros (horário de Brasília).",
          icone: "far fa-clock",
          desabilitada: false
        }
      ];
    },
    // sem canal web configurado o envio cai sempre em somente aplicativo
    canalEnvio() {
      if (!this.canalWebDisponivel) return "app";
      return this.filter.canal || "ambos";
    }
  },
  components: {
    Panel,
    FormButton,
    FormSelect,
    FormField,
    FormText,
    FormDatePicker,
    FormCheckbox,
    FormAutocomplete,
    MarketingModules
  },
  data: () => ({
    isLoading: false,
    atendentesResult: [],
    searchComplete: false,
    form: {
      messageLink: "",
      linkIsValid: false
    },
    filter: { canal: "ambos" },
    quando: QUANDO_AGORA,
    agendamento: { data: "", hora: "" },
    errosAgendamento: {},
    idAgendamentoEdicao: null,
    canalWebDisponivel: false,
    segmentos: [],
    fornecedores: [],
    clientes: [],
    clientesSelecionados: [],
    listaDestinatarios: [],
    offset: 0,
    modulosForm: [ModulesEnum.ORCAMENTO_APP, ModulesEnum.COMMERCE_APP],
    linkRegex: /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/
  }),
  methods: {
    goToReport(aba) {
      const path = "/fornecedor/marketing/push-notification/relatorio";
      if (typeof aba === "string") {
        this.$router.push({ path, query: { aba } });
        return;
      }
      this.$router.push(path);
    },
    selecionarQuando(opcao) {
      if (opcao.desabilitada) return;
      this.quando = opcao.valor;
      this.errosAgendamento = {};
    },
    selecionarCanal(opcao) {
      if (opcao.desabilitada) return;
      this.$set(this.filter, "canal", opcao.valor);
    },
    getCanalWebDisponivel() {
      ApiWeb.v4.marketing.push
        .canalWebDisponivel(this.getFornecedorId)
        .then(resp => {
          this.canalWebDisponivel = !!(
            resp &&
            resp.data &&
            resp.data.canal_web_disponivel
          );
          if (!this.canalWebDisponivel) {
            this.$set(this.filter, "canal", "app");
          }
        })
        .catch(() => {
          this.canalWebDisponivel = false;
          this.$set(this.filter, "canal", "app");
        });
    },
    onSearchAtendente(value) {
      ApiWeb.v4.usuario
        .pesquisa(this.getFornecedorId, value || "")
        .then(resp => {
          this.atendentesResult = _.uniqBy(
            this.atendentesResult.concat(resp.data),
            "idusuario"
          );
        });
    },
    formataNome(item) {
      if (item.nome == item.nomeusuario) {
        return item.nome;
      }
      return `${item.nome} | ${item.nomeusuario}`;
    },
    verifyMessageLink() {
      if (this.form.messageLink === "") {
        this.form.linkIsValid = true;
        return this.form.linkIsValid;
      }
      if (!this.form.messageLink.startsWith("http")) {
        this.form.messageLink = "http://" + this.form.messageLink;
      }
      this.form.linkIsValid = this.linkRegex.test(this.form.messageLink);
      return this.form.linkIsValid;
    },
    getSegmentos() {
      this.isLoading = true;
      this.$store
        .dispatch(SEGMENTO_CLIENTE_LIST, {
          idfornecedor: this.getFornecedorId
        })
        .then(data => {
          this.segmentos = (data || []).map(v => {
            return { value: v.idsegmentocliente, text: v.nome };
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getFornecedores() {
      this.isLoading = true;
      this.$store
        .dispatch(FORNECEDOR_LOAD_ALL)
        .then(data => {
          this.fornecedores = (data || []).map(v => {
            return { value: v.idfornecedor, text: v.nome };
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getClientes(clear) {
      if (clear) {
        this.offset = 0;
        this.clientes = [];
      }
      if (this.isLoading) return;
      const data = this.getParams();
      this.isLoading = true;
      this.$store
        .dispatch(NOTIFICACAO_PUSH_LOAD_CLIENTS, data)
        .then(data => {
          this.clientes = this.clientes.concat(data);
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onScroll(event) {
      const scrollContainer = event.target;
      if (
        scrollContainer.scrollTop + scrollContainer.clientHeight >=
        scrollContainer.scrollHeight - 10
      ) {
        this.offset += 100;
        this.getClientes(false);
      }
    },
    getParams() {
      return {
        idfornecedor: this.getFornecedorId,
        cadastroStart: this.queryDate(true, this.filter.dataCadastroIni),
        cadastroEnd: this.queryDate(false, this.filter.dataCadastroFim),
        compraStart: this.queryDate(true, this.filter.dataUltimaCompraIni),
        compraEnd: this.queryDate(false, this.filter.dataUltimaCompraFim),
        acessoStart: this.queryDate(true, this.filter.dataUltimoAcessoIni),
        acessoEnd: this.queryDate(false, this.filter.dataUltimoAcessoFim),
        nascimentoStart: this.queryDate(true, this.filter.dataNascimentoIni),
        nascimentoEnd: this.queryDate(false, this.filter.dataNascimentoFim),
        carrinhoAberto: this.filter.carrinhoAberto || "",
        cadastroAprovado: this.filter.cadastroaprovado || "",
        segmentosSelecionados: this.filter.segmentosSelecionados,
        fornecedoresSelecionados: this.filter.fornecedoresSelecionados,
        atendentesPadrao: this.filter.atendentesPadrao || [],
        canal: this.canalEnvio,
        limit: 100,
        offset: this.offset || 0
      };
    },
    onSubmit() {
      this.verifyMessageLink();
      if (!this.form.messageText || !this.form.messageTitle) {
        this.$vueOnToast.pop("error", "O título e mensagem são obrigatórios!");
        return;
      }
      if (this.listaDestinatarios.length == 0 && !this.filter.enviarParaTodos) {
        this.$vueOnToast.pop(
          "error",
          "Selecione ao menos um cliente para enviar notificação."
        );
        return;
      }
      if (!this.form.linkIsValid) {
        this.$vueOnToast.pop(
          "error",
          "O link inserido é inválido! Confira também se a página está acessível."
        );
        return;
      }
      if (this.agendando) {
        this.salvarAgendamento();
        return;
      }
      let tokens = [];
      let searchParams = null;
      this.$vueOnToast.pop(
        "info",
        "Iniciando o processo de envio de notificações...",
        1000
      );
      if (!this.filter.enviarParaTodos) {
        this.listaDestinatarios.map(dest => {
          dest.tokens.map(token => {
            tokens.push(token);
          });
        });
        // remove tokens duplicados
        tokens = tokens.filter((v, i, a) => a.indexOf(v) === i);
      } else {
        searchParams = this.getParams();
      }
      const data = {
        tokens: tokens,
        titulo: this.form.messageTitle,
        mensagem: this.form.messageText,
        link: this.form.messageLink,
        canal: this.canalEnvio,
        dadosBuscaClientes: searchParams
      };
      this.isLoading = true;
      this.$store
        .dispatch(NOTIFICACAO_PUSH_SEND, data)
        .then(response => {
          setTimeout(() => {
            if (response.ok) {
              this.isLoading = false;
              this.$vueOnToast.pop(
                "success",
                this.filter.enviarParaTodos
                  ? "As notificações serão enviadas em breve."
                  : "Notificação enviada com sucesso."
              );
              this.form = {
                messageLink: "",
                linkIsValid: false
              };
              this.filter = {};
              this.clientesSelecionados = [];
              this.listaDestinatarios = [];
              this.clientes = [];
            } else {
              this.isLoading = false;
              this.$vueOnToast.pop("error", "Falha ao enviar notificações!");
            }
          }, 1100);
        })
        .catch(() => {
          this.$vueOnToast.pop("error", "Falha ao enviar notificações!");
          this.isLoading = false;
        });
    },
    montarPayloadAgendamento() {
      const { limit, offset, ...filtrosBusca } = this.getParams(); // eslint-disable-line no-unused-vars
      return {
        titulo: this.form.messageTitle,
        mensagem: this.form.messageText,
        link: this.form.messageLink,
        canal: this.canalEnvio,
        data: this.agendamento.data,
        hora: this.agendamento.hora,
        enviarParaTodos: !!this.filter.enviarParaTodos,
        idclientes: this.listaClientes.map(c => c.idcliente),
        dadosBuscaClientes: {
          ...filtrosBusca,
          // permitem reabrir o cadastro na edicao
          telaFiltros: { ...this.filter },
          telaDestinatarios: this.listaClientes.map(c => ({
            idcliente: c.idcliente,
            nome: c.nome
          }))
        }
      };
    },
    salvarAgendamento() {
      const erros = validarDataHoraAgendamento(
        this.agendamento.data,
        this.agendamento.hora
      );
      if (Object.keys(erros).length) {
        this.errosAgendamento = erros;
        this.$vueOnToast.pop(
          "error",
          "Informe uma data e horário futuros (horário de Brasília)."
        );
        return;
      }
      this.errosAgendamento = {};
      const payload = this.montarPayloadAgendamento();
      this.isLoading = true;
      const request = this.editando
        ? this.$store.dispatch(NOTIFICACAO_PUSH_ATUALIZAR_AGENDAMENTO, {
            id: this.idAgendamentoEdicao,
            payload
          })
        : this.$store.dispatch(NOTIFICACAO_PUSH_AGENDAR, payload);
      request
        .then(() => {
          this.$vueOnToast.pop(
            "success",
            `Notificação agendada para ${moment(
              payload.data,
              "YYYY-MM-DD"
            ).format("DD/MM/YYYY")} às ${payload.hora} (horário de Brasília).`
          );
          const foiEdicao = this.editando;
          this.limparFormulario();
          if (foiEdicao) {
            this.goToReport("agendamentos");
          }
        })
        .catch(erro => this.tratarErroAgendamento(erro))
        .finally(() => {
          this.isLoading = false;
        });
    },
    tratarErroAgendamento(erro) {
      const campos = (erro && erro.campos) || {};
      this.errosAgendamento = {
        data: campos.data || "",
        hora: campos.hora || ""
      };
      this.$vueOnToast.pop(
        "error",
        (erro && erro.mensagem) || "Falha ao agendar a notificação!"
      );
      if (erro && erro.status === 409) {
        this.goToReport("agendamentos");
      }
    },
    limparFormulario() {
      this.form = { messageLink: "", linkIsValid: false };
      this.filter = { canal: this.canalEnvio };
      this.clientesSelecionados = [];
      this.listaDestinatarios = [];
      this.clientes = [];
      this.quando = QUANDO_AGORA;
      this.agendamento = { data: "", hora: "" };
      this.errosAgendamento = {};
      this.idAgendamentoEdicao = null;
    },
    carregarAgendamento(id) {
      this.isLoading = true;
      this.$store
        .dispatch(NOTIFICACAO_PUSH_GET_AGENDAMENTO, id)
        .then(ag => {
          if (!podeAlterarAgendamento(ag.status)) {
            this.$vueOnToast.pop("error", MENSAGEM_EM_PROCESSAMENTO);
            this.goToReport("agendamentos");
            return;
          }
          const filtros = ag.filtros || {};
          this.idAgendamentoEdicao = ag.id;
          this.quando = QUANDO_AGENDAR;
          this.agendamento = separarDataHoraBrasilia(ag.data_agendada);
          this.form = {
            messageTitle: ag.titulo,
            messageText: ag.mensagem,
            messageLink: ag.link || "",
            linkIsValid: true
          };
          this.filter = {
            ...(filtros.telaFiltros || {}),
            canal: ag.canal,
            enviarParaTodos: ag.tipo_destinatario === "todos"
          };
          // trocar filter.canal limpa as listas: restaura apos o watcher
          this.$nextTick(() => {
            if (ag.tipo_destinatario === "selecionados") {
              const destinatarios =
                filtros.telaDestinatarios ||
                (ag.idclientes || []).map(idcliente => ({
                  idcliente,
                  nome: idcliente
                }));
              this.clientes = destinatarios;
              this.clientesSelecionados = destinatarios.map(c => c.idcliente);
              this.listaDestinatarios = destinatarios;
            }
          });
        })
        .catch(() => {
          this.goToReport("agendamentos");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    formataData(data) {
      const date = data ? moment(data, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
      return date;
    },
    queryDate(start, date) {
      if (start && date) {
        return moment(date, "YYYY-MM-DD")
          .startOf("day")
          .format("YYYY-MM-DDTHH:mm:ss");
      } else if (!start && date) {
        return moment(date, "YYYY-MM-DD")
          .endOf("day")
          .format("YYYY-MM-DDTHH:mm:ss");
      }
      return "";
    },
    addCliente(cliente) {
      this.clientesSelecionados.push(cliente.idcliente);
      this.listaDestinatarios.push(cliente);
    },
    removeCliente(cliente) {
      this.clientesSelecionados = this.clientesSelecionados.filter(
        c => c !== cliente.idcliente
      );
      this.listaDestinatarios = this.listaDestinatarios.filter(
        c => c.idcliente !== cliente.idcliente
      );
    },
    addAllCliente(clientes) {
      this.clientesSelecionados = [];
      this.listaDestinatarios = [];
      this.clientesSelecionados = clientes.map(c => c.idcliente);
      this.listaDestinatarios = clientes;
    },
    removeAllCliente() {
      this.clientesSelecionados = [];
      this.listaDestinatarios = [];
    }
  },
  watch: {
    "filter.enviarParaTodos"(newValue) {
      if (newValue) {
        this.removeAllCliente();
      }
    },
    // trocar o canal muda o recorte de destinatarios: a lista pesquisada
    // antes da troca nao vale mais
    "filter.canal"() {
      this.clientes = [];
      this.clientesSelecionados = [];
      this.listaDestinatarios = [];
      this.offset = 0;
      this.searchComplete = false;
    }
  },
  created() {
    this.getSegmentos();
    this.getFornecedores();
    this.getCanalWebDisponivel();
    if (this.$route.query.agendamento) {
      this.carregarAgendamento(this.$route.query.agendamento);
    }
  }
};
</script>

<style scoped>
.secao-titulo {
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
}
.secao-subtitulo {
  text-align: center;
  font-size: 0.8125rem;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 4px;
}
.canal-opcao {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid #dfe3e8;
  border-radius: 8px;
  cursor: pointer;
  height: 100%;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}
.canal-opcao:hover {
  border-color: var(--primary-color);
}
.canal-opcao--ativa {
  border: 2px solid var(--primary-color);
  background-color: rgba(25, 118, 210, 0.04);
}
.canal-opcao--desabilitada {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #fafafa;
}
.canal-opcao--desabilitada:hover {
  border-color: #dfe3e8;
}
.canal-opcao__texto {
  text-align: left;
}
.canal-opcao__icones {
  display: flex;
  align-items: center;
}
.canal-opcao__icone-wrapper {
  display: inline-flex;
  align-items: center;
}
.canal-opcao__icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 6px;
  background-color: rgba(25, 118, 210, 0.08);
}
.canal-opcao__mais {
  margin: 0 4px;
  color: rgba(0, 0, 0, 0.4);
  font-size: 0.75rem;
}
.canal-opcao__titulo {
  text-align: left;
  font-weight: 600;
  font-size: 0.9375rem;
  line-height: 1.2;
  color: var(--primary-color);
}
.canal-opcao--desabilitada .canal-opcao__titulo {
  color: rgba(0, 0, 0, 0.6);
}
.canal-opcao__descricao {
  text-align: left;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 2px;
}
.canal-aviso {
  text-align: left;
  display: flex;
  align-items: center;
  padding: 10px 14px;
  border-radius: 6px;
  background-color: rgba(25, 118, 210, 0.06);
  font-size: 0.8125rem;
  color: rgba(0, 0, 0, 0.75);
}
.static-texts-container {
  max-height: 450px;
  overflow-y: auto;
}
.preview-smartphone {
  position: absolute;
  width: 80%;
  min-height: 15%;
  top: 50%;
  left: 10%;
}
.border-left {
  border-left: 1px solid #ccc;
}
.scroll-container {
  height: 600px;
  overflow-y: auto;
}
</style>
